import React from 'react';
const LikeSVG = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={props.onClick}
    >
      <g id="Group 19816">
        <path
          id="Vector (Stroke)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.45038 3.78693C9.66302 3.30841 10.1375 3 10.6612 3C12.0533 3 13.1818 4.12852 13.1818 5.52061V8.09091H15.7296C17.5125 8.09091 18.876 9.68014 18.6049 11.4424L17.8217 16.5333C17.6033 17.9524 16.3822 19 14.9463 19H5.18182C3.97684 19 3 18.0232 3 16.8182V11.7273C3 10.5223 3.97684 9.54545 5.18182 9.54545H6.89099L9.45038 3.78693ZM8.09091 17.5455H14.9463C15.6643 17.5455 16.2748 17.0217 16.384 16.3121L17.1672 11.2212C17.3028 10.3401 16.621 9.54545 15.7296 9.54545H13.1818C12.3785 9.54545 11.7273 8.89422 11.7273 8.09091V5.52061C11.7273 4.95968 11.2941 4.49994 10.744 4.45771L8.22021 10.1361C8.2202 10.1361 8.22021 10.1361 8.22021 10.1361C8.18381 10.218 8.1404 10.2954 8.09091 10.3677V17.5455ZM6.63636 11V17.5455H5.18182C4.78015 17.5455 4.45455 17.2199 4.45455 16.8182V11.7273C4.45455 11.3256 4.78015 11 5.18182 11H6.63636ZM10.7796 4.37761C10.7796 4.37768 10.7796 4.37753 10.7796 4.37761V4.37761Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export default LikeSVG;
